import { useMyPageData, useTimeline } from 'src/api/mypage'
import { withLoginUser } from 'src/api/user'
import { MyPageLayout } from './MyPageLayout'

export const MyPage = withLoginUser(({ user }) => {
  const myPageData = useMyPageData()
  const timeline = useTimeline(user.id)
  const mutateTimeline = timeline.mutate

  if (myPageData.isValidating || timeline.isValidating) {
    // TOOD Loading
  }
  const {
    newUsers = [],
    articles = [],
    popUp,
    modalArticle,
    advertisements = [],
    events = [],
  } = myPageData.data || {}
  return (
    <MyPageLayout
      user={user}
      newUsers={newUsers}
      articles={articles}
      popUp={popUp}
      modalArticle={modalArticle}
      timeline={timeline.data || []}
      mutateTimeline={mutateTimeline}
      advertisements={advertisements}
      events={events}
    />
  )
})
